<template>
  <div>
    <button
      class="px-5 py-2 rounded-l bg-white border border-r-0 border-gray-200 hover:bg-gray-50"
      :disabled="value === 1"
      @click="$emit('input', value - 1)"
    >
      <i class="zmdi zmdi-chevron-left"></i>
    </button>
    <button
      class="px-5 py-2 border"
      v-for="i in totalPages"
      :class="[value === i ? 'bg-easyGreen text-white border-easyGreen' : 'bg-white border-gray-200 border-r-0 hover:bg-gray-50']"
      :key="i"
      @click="$emit('input', i)">
      {{ i }}
    </button>
    <button
      class="px-5 py-2 rounded-r bg-white border border-gray-200 hover:bg-gray-50"
      :disabled="value === totalPages"
      @click="$emit('input', value + 1)"
    >
      <i class="zmdi zmdi-chevron-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  }
}
</script>
